import { CalendarCheck, MailCheck, BellRing, Star } from "lucide-react";

const STATE = { ok: "#0f9d6b", pending: "#94a3b8", err: "#e11d2a" };

// Derive automation indicators strictly from real backend fields on the appointment.
export function apptAutomations(a) {
  if (!a || a._kind === "request") return [];
  const out = [];
  const g = a.gcal_status;
  if (g && g !== "disabled") {
    const state = g === "synced" ? "ok" : g === "error" ? "err" : "pending";
    out.push({ key: "google", icon: CalendarCheck, label: "Google", state,
      text: g === "synced" ? "Synchronisé avec Google Agenda" : g === "error" ? "Échec de synchronisation Google" : "En attente de connexion Google" });
  }
  if (a.confirmation_sent || a.confirmation_status) {
    const state = a.confirmation_sent ? "ok" : (a.confirmation_status === "error" ? "err" : "pending");
    out.push({ key: "confirm", icon: MailCheck, label: "Confirmation", state,
      text: a.confirmation_sent ? "Confirmation envoyée" : (a.confirmation_status === "error" ? "Échec d'envoi de la confirmation" : "Confirmation en attente") });
  }
  if (a.reminder_enabled) {
    const ok = a.reminder_sent && a.reminder_skipped !== "passe";
    out.push({ key: "reminder", icon: BellRing, label: "Rappel", state: ok ? "ok" : "pending",
      text: ok ? "Rappel envoyé" : "Rappel programmé" });
  }
  if (a.review_request_sent || a.review_request_status) {
    const state = a.review_request_sent ? "ok" : (a.review_request_status === "error" ? "err" : "pending");
    out.push({ key: "review", icon: Star, label: "Avis", state,
      text: a.review_request_sent ? "Demande d'avis envoyée" : (a.review_request_status === "error" ? "Échec de la demande d'avis" : "Demande d'avis en attente") });
  }
  return out;
}

export function ApptBadges({ a, compact = false }) {
  const items = apptAutomations(a);
  if (!items.length) return null;
  if (compact) {
    return (
      <span className="flex items-center gap-0.5 shrink-0" data-testid="appt-automations">
        {items.map((it) => (
          <span key={it.key} title={`${it.label} : ${it.text}`} data-testid={`appt-badge-${it.key}-${it.state}`}
            className="inline-flex items-center justify-center rounded-full" style={{ background: "rgba(255,255,255,.85)", width: 14, height: 14 }}>
            <it.icon style={{ color: STATE[it.state], width: 9, height: 9 }} strokeWidth={2.75} />
          </span>
        ))}
      </span>
    );
  }
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="appt-automations-full">
      {items.map((it) => (
        <span key={it.key} title={it.text} data-testid={`appt-badge-${it.key}-${it.state}`}
          className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full border"
          style={{ color: STATE[it.state], borderColor: STATE[it.state] + "55", background: STATE[it.state] + "14" }}>
          <it.icon className="w-3 h-3" strokeWidth={2.5} />
          {it.label}
          <span className="font-semibold">{it.state === "ok" ? "✓" : it.state === "err" ? "!" : "⏳"}</span>
        </span>
      ))}
    </div>
  );
}
